/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {MicroSiteDomains} from '../models/MicroSiteDomains';

export interface GetMicroSitesDomains$Request {
    accountId: number;
}

export interface GetMicroSitesDomains$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getMicroSitesDomainsRequest = createAction<PayloadData<void, GetMicroSitesDomains$Request>>('MICRO_SITES_DOMAINS__GET_MICRO_SITES_DOMAINS__REQUEST');
export const getMicroSitesDomainsSuccess = createAction<PayloadData<MicroSiteDomains, GetMicroSitesDomains$Request>>('MICRO_SITES_DOMAINS__GET_MICRO_SITES_DOMAINS__SUCCESS');
export const getMicroSitesDomainsFailure = createAction<PayloadData<Error, GetMicroSitesDomains$Request, true>>('MICRO_SITES_DOMAINS__GET_MICRO_SITES_DOMAINS__FAILURE');

export const getMicroSitesDomainsActions = [
    getMicroSitesDomainsRequest,
    getMicroSitesDomainsSuccess,
    getMicroSitesDomainsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getMicroSitesDomains = (meta: GetMicroSitesDomains$Request, config?: GetMicroSitesDomains$Config) => {
    return {
        CALL_API: {
            types: getMicroSitesDomainsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/microsites/domains`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateMicroSitesDomains$Request {
    accountId: number;
    microSiteDomains: MicroSiteDomains;
}

export interface UpdateMicroSitesDomains$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateMicroSitesDomainsRequest = createAction<PayloadData<void, UpdateMicroSitesDomains$Request>>('MICRO_SITES_DOMAINS__UPDATE_MICRO_SITES_DOMAINS__REQUEST');
export const updateMicroSitesDomainsSuccess = createAction<PayloadData<void, UpdateMicroSitesDomains$Request>>('MICRO_SITES_DOMAINS__UPDATE_MICRO_SITES_DOMAINS__SUCCESS');
export const updateMicroSitesDomainsFailure = createAction<PayloadData<Error, UpdateMicroSitesDomains$Request, true>>('MICRO_SITES_DOMAINS__UPDATE_MICRO_SITES_DOMAINS__FAILURE');

export const updateMicroSitesDomainsActions = [
    updateMicroSitesDomainsRequest,
    updateMicroSitesDomainsSuccess,
    updateMicroSitesDomainsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {MicroSiteDomains} meta.microSiteDomains
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateMicroSitesDomains = (meta: UpdateMicroSitesDomains$Request, config?: UpdateMicroSitesDomains$Config) => {
    return {
        CALL_API: {
            types: updateMicroSitesDomainsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/accounts/${meta.accountId}/microsites/domains`,
            TRANSPORT_REQUEST_BODY: meta.microSiteDomains,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface ValidateMicrositeDomain$Request {
    domain: string;
}

export interface ValidateMicrositeDomain$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const validateMicrositeDomainRequest = createAction<PayloadData<void, ValidateMicrositeDomain$Request>>('MICRO_SITES_DOMAINS__VALIDATE_MICROSITE_DOMAIN__REQUEST');
export const validateMicrositeDomainSuccess = createAction<PayloadData<void, ValidateMicrositeDomain$Request>>('MICRO_SITES_DOMAINS__VALIDATE_MICROSITE_DOMAIN__SUCCESS');
export const validateMicrositeDomainFailure = createAction<PayloadData<Error, ValidateMicrositeDomain$Request, true>>('MICRO_SITES_DOMAINS__VALIDATE_MICROSITE_DOMAIN__FAILURE');

export const validateMicrositeDomainActions = [
    validateMicrositeDomainRequest,
    validateMicrositeDomainSuccess,
    validateMicrositeDomainFailure
] as const;

/**
 * @param {string} meta.domain
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const validateMicrositeDomain = (meta: ValidateMicrositeDomain$Request, config?: ValidateMicrositeDomain$Config) => {
    const TRANSPORT_GET_PARAMS = {
        domain: meta.domain,
    };
    return {
        CALL_API: {
            types: validateMicrositeDomainActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/microsites/domain/validate`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

